'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from 'next/image';
import Link from 'next/link';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';

interface LogoProps {
  src?: string;
  alt?: string;
  generalLayout: GeneralLayout['data'];
  className: {
    link?: string;
    image: string;
  };
}

export function Logo({ src, alt, generalLayout, className }: LogoProps) {
  return (
    <Link
      href={ROUTES.HOME()}
      className={cn('cursor-pointer transition-all ease-in-out hover:opacity-75', className?.link)}
    >
      <Image
        src={src || generalLayout?.header?.logo?.url || '/placeholder.png'}
        alt={typeof alt === 'string' ? alt : resolveImageAlt((src ? undefined : generalLayout?.header?.logo), alt ?? (generalLayout?.site_name?.trim() || ''))}
        width={0}
        height={0}
        className={cn('w-auto shrink-0 object-contain object-center', className?.image)}
        sizes="100vw"
      />
    </Link>
  );
}
